import { Suspense } from 'react'
import { ErrorBoundary } from './ErrorBoundary.tsx'
import { RemotePageLoading } from '@carouselgg/auth/remote-chrome'
import { getRemote } from './remotes.ts'

interface RemoteLoaderProps {
  name: string
}

export function RemoteLoader({ name }: RemoteLoaderProps) {
  const RemoteComponent = getRemote(name)

  return (
    <ErrorBoundary name={name}>
      <Suspense fallback={<RemotePageLoading />}>
        <RemoteComponent />
      </Suspense>
    </ErrorBoundary>
  )
}
